import { useTranslation } from "react-i18next"

import { NewRfq, Rfqs } from "@/App/Credit"
import { CreditTrades } from "@/App/Trades"
import { BottomNavigation } from "@/components/BottomNavigation"

import {
  MobileCreditTab,
  setMobileCreditTab,
  useMobileCreditTab,
} from "./mobileCreditTab.state"

export const MobileCreditPage = () => {
  const { t } = useTranslation()
  const activeTab = useMobileCreditTab()

  const CREDIT_TABS = [
    {
      key: MobileCreditTab.Rfqs,
      label: t("navigation.credit.rfqs"),
      icon: "cards",
    },
    {
      key: MobileCreditTab.Trade,
      label: t("navigation.credit.trade"),
      icon: "eye",
    },
    {
      key: MobileCreditTab.NewRfq,
      label: t("navigation.credit.newRfq"),
      icon: "plus",
    },
  ] as const

  return (
    <div className="flex h-full w-full flex-col overflow-hidden">
      <div className="flex-1 overflow-hidden">
        <div
          className="h-full w-full"
          hidden={activeTab !== MobileCreditTab.Rfqs}
        >
          <Rfqs />
        </div>
        <div
          className="h-full w-full"
          hidden={activeTab !== MobileCreditTab.Trade}
        >
          <CreditTrades />
        </div>
        <div
          className="h-full w-full"
          hidden={activeTab !== MobileCreditTab.NewRfq}
        >
          <NewRfq />
        </div>
      </div>
      <BottomNavigation
        tabs={CREDIT_TABS}
        activeTab={activeTab}
        onTabChange={(key: string) =>
          setMobileCreditTab(key as MobileCreditTab)
        }
      />
    </div>
  )
}
